<div class="">
  <div class="app-gutters list-page-gutters">
    <div>
      <dxo-card [bodyHeader]="taxBodyHeader" data-e2e="tax-body-header">
        <card-body>
          <div class="loader-container" *ngIf="isTaxLoading">
            <dxo-circular-loader text="Loading..." [size]="'medium'" [color]="'blue'"></dxo-circular-loader>
          </div>
          <div>
            <dxo-table [stickyColumn]="false" [data]="taxDataTable"> </dxo-table>
          </div>
        </card-body>
      </dxo-card>
    </div>

    <div class="card-container">
      <dxo-card [bodyHeader]="scheduleAHeader" class="letters-card" data-e2e="schedule-a-header">
        <card-body>
          <ng-container>
            <div class="loader-container" *ngIf="isLetterLoading; else showLetters">
              <dxo-circular-loader text="Loading..." [size]="'medium'" [color]="'blue'"></dxo-circular-loader>
            </div>
            <div>
              <app-p8-documents-error-page
                *ngIf="hasServerError"
                [messageHeader]="messageHeader"
                [messageBody]="messageBody"
              >
              </app-p8-documents-error-page>
            </div>
            <div>
              <ng-template #showLetters>
                <div *ngIf="!hasServerError && !isLetterLoading">
                  <div *ngIf="totalLines > 0">
                    <div>
                      <dxo-table [stickyColumn]="false" [data]="scheduleADataTable"> </dxo-table>
                    </div>
                    <div (click)="seeMoreLess()" (keydown)="seeMoreLess()" class="morelesslink" *ngIf="totalLines > 0" data-e2e="see-more-text">
                      {{ seeMoreLessText }}
                    </div>
                  </div>
                  <div *ngIf="totalLines === 0">
                    <div>There are no letters to display. Request a custom Schedule A letter if needed.</div>
                  </div>
                </div>
              </ng-template>
            </div>
          </ng-container>
        </card-body>
      </dxo-card>

      <dxo-card [bodyHeader]="requestHeader" data-e2e="request-header">
        <card-body>
          <div>
            <form [formGroup]="formGroup" (ngSubmit)="submit()" #myForm="ngForm">
              <div class="data-containter">
                <div>
                  <h3>Specific date range:</h3>
                  <dxo-text-input
                    [label]="startDateLabel"
                    class="input-200"
                    input-id="fromDate"
                    [maxlength]="10"
                    autocomplete="fromDay"
                    type="date"
                    [characterSet]="dateCharRegex"
                    formControlName="fromDate"
                    [errorControl]="formErrors.fromDate"
                    [dxoDataset]="[{ selector: 'input', data: { e2e: 'schedule-a-start-date-input' } }]"
                  >
                  </dxo-text-input>
                  <dxo-text-input
                    [label]="endDateLabel"
                    class="input-200"
                    input-id="ToDate"
                    [maxlength]="10"
                    autocomplete="toDay"
                    type="date"
                    [characterSet]="dateCharRegex"
                    formControlName="toDate"
                    [errorControl]="formErrors.toDate"
                    [dxoDataset]="[{ selector: 'input', data: { e2e: 'schedule-a-end-date-input' } }]"
                  >
                  </dxo-text-input>
                </div>
              </div>
              <dxo-button
                [primary]="true"
                text="Submit request"
                data-category="request"
                data-action="Close Modal"
                (handleClick)="request()"
                [disabled]="!pageValid()"
              >
              </dxo-button>
            </form>
          </div>
        </card-body>
      </dxo-card>
    </div>
  </div>
</div>

<dxo-modal *ngIf="open && !modalSuccess" [shouldShowCloseX]="false">
  <modal-body class="loader-container">
    <dxo-circular-loader text="Loading..." [size]="'medium'" [color]="'blue'"></dxo-circular-loader>
  </modal-body>
</dxo-modal>
<dxo-modal
  *ngIf="open && modalSuccess"
  title="We received your Schedule A request"
  [maxWidth]="470"
  [shouldShowCloseX]="false"
>
  <modal-body>
    <p>Thank you for your request. Processing the request may take two business days to complete.</p>
    <p>An email confirmation is on the way.</p>
    <dxo-button text="Close" color="blue" (handleClick)="closePopup()"></dxo-button>
  </modal-body>
</dxo-modal>
